// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";

@jsonObject
export default class StellarInitialize extends PerunMessage {
  @jsonMember(String) clientAddress: string;
  @jsonMember(Boolean) egoisticClient = true;

  constructor(clientAddress: string) {
    super();
    this.clientAddress = clientAddress;
  }

  messageType(): MessageType {
    return StellarInitialize;
  }

  messageTypeName(): MessageTypeName {
    return "StellarInitialize";
  }
}
